import * as React from "react";
import "./ChatMessageEditor.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextareaAutosize from "react-textarea-autosize";
import { useEffect, useRef, useState } from "react";
import { EventHistoryUtils } from "../../EventHistoryList.util";
import { MenuButton } from "../../../../../../components/menu-button/MenuButton.component";
import { useTranslation } from "react-i18next";
const ttPos = "top-right";
export function ChatMessageEditor({ visible, filterOptions }) {
    const [currentText, setCurrentText] = useState("");
    const textAreaRef = useRef(null);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        if (!textAreaRef.current) {
            throw new Error("textAreaRef.current is null");
        }
        textAreaRef.current.onkeydown = (e) => {
            if (e.key === "Enter") {
                if (!e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                }
            }
        };
    }, []);
    useEffect(() => {
        if (textAreaRef.current) {
            if (visible) {
                textAreaRef.current.placeholder = EventHistoryUtils.placeholderTypeAMessage();
            }
            else {
                textAreaRef.current.placeholder = "";
                clearInput();
            }
        }
    }, [visible, i18n.language]);
    const sendMessage = () => {
        var _a;
        if ((_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            EventHistoryUtils.sendChatMessage(textAreaRef.current.value);
            clearInput();
        }
    };
    const clearInput = () => {
        if (textAreaRef.current) {
            textAreaRef.current.value = "";
            setCurrentText("");
        }
    };
    return (React.createElement("div", { className: "chat-message-editor-container" },
        React.createElement(TextareaAutosize, { className: "chat-message-editor-textarea", ref: textAreaRef, minRows: 1, maxRows: 5, onChange: (e) => {
                setCurrentText(e.target.value);
            } }),
        React.createElement("div", { className: "chat-message-editor-buttons" },
            filterOptions.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(MenuButton, { menuPlacement: "top-right", options: filterOptions, menuTitle: t("chatview:button-filter-menu-title", "Filter message types"), icon: "filter", closeOnSelect: false, tooltip: t("chatview:button-filter-tooltip", "Filter by message types"), tooltipPosition: ttPos }),
                React.createElement("div", { className: "chat-message-editor-buttons-separator" }))),
            React.createElement("button", { className: "chat-message-editor-button icon-button", disabled: !currentText, onClick: clearInput, "data-tooltip": t("chatview:button-clear-input-tooltip", "Clear message input field"), "data-tooltip-disabled": t("chatview:button-clear-input-tooltip-disabled", "Message input field is already empty"), "data-tooltip-position": ttPos },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "trash"] })),
            React.createElement("div", { style: { flexGrow: 1 } }),
            React.createElement("button", { className: "chat-message-editor-send-button icon-button highlight-button", disabled: !currentText, onClick: sendMessage, "data-tooltip": EventHistoryUtils.ttSendMessageButton(), "data-tooltip-disabled": EventHistoryUtils.ttSendMessageButtonDisabled(), "data-tooltip-position": ttPos },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "paper-plane"] })))));
}
